import { FormlyFieldConfig } from "@ngx-formly/core";
import { AllegatiBolliAltroStep } from "../../shared/allegati-bolli-altro.step";

export const AllegatiScavoStep: FormlyFieldConfig[] = [
    {
      "props": { "label": 'ALLEGATI ' },
      "fieldGroup": [
        {
          "key": 'allegati_foto_luogo',
          "type": 'mat-upload',
          "props": {
            "label": "FOTO ATTUALE DEL LUOGO DI OCCUPAZIONE",
            "multiple": true,
            "required":true
          },
        },
        {
          'key':'allegati_visure',
          "type": 'mat-upload',
          "props": {
            "label": " VISURA CAMERALE DI CIASCUNA DITTA ESECUTRICE DEI LAVORI",
            "multiple": true,
            "required":true
          },
          "expressions":{
            'hide': "model.jd.ditta_opt == 'si'"
          },
        },
        {
          'key':'allegati_autocertificazione_1mq',
          "type": 'mat-upload',
          "props": {
            "label": "AUTOCERTIFICAZIONE MANOMISSIONE DEL SUOLO AL MASSIMO PER 1 MQ",
            "multiple": true,
            "required":true
          },
          "expressions":{
            'hide': "model.jd.ditta_opt === 'si'"
          },
        },
        {
          "key": 'allegati_elaborati',
          "type": 'mat-upload',
          "props": {
            "label": "ELABORATI GRAFICI, PLANIMETRIE E SEZIONI ",
            "multiple": true,
            "required":true
          }
        },
        {
          "key": 'allegati_pareri',
          "type": 'mat-upload',
          "props": {
            "label": "PARERI / NULLA OSTA",
            "multiple": true,
          }
        },
        {
          "key": 'allegati_nullaosta_monitoraggio',
          "type": 'mat-upload',
          "props": {
            "label": "ALLEGARE NULLAOSTA MONITORAGGIO",
            "multiple": true,
          }
        },
      ]
    },
  ]
